import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { ComponentContext } from '../context/componentContext';
import { AuthContext } from '../context/authContext';

import SessionExpired from './sessionExpired';
import { UnderLay } from '../components/Loading';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, session } = useContext(AuthContext);
  const { loading } = useContext(ComponentContext);

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <>
            {!session && <SessionExpired />}
            {loading && <UnderLay />}
            <Component {...props} />
          </>
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PrivateRoute;
